import { ItemData } from 'core/models/Template'

export const LIGHT_OF_HISTORY_CATALOG_TYPE = 'lightOfHistory' as const

export const LIGHT_OF_HISTORY_CATALOG_CONFIG = {
    type: LIGHT_OF_HISTORY_CATALOG_TYPE,
    treeView: false,
    additionalData: {},
    fixedHeader: true,
    isExistRightToolbar: false,
    hideHeader: true,
    handleSortable: true,
} as const

export type LightOfHistorySelectedItems = ItemData[]
